import type { AnyError } from "@pdfking/errors"
import { Failure } from "@pdfking/errors"

import type { AsyncSequence } from "#public"

import { Void } from "../functions/Void"

export const SafeIterable = <T>(
  stream: AsyncSequence<T>,
  cleanup: (error: AnyError | undefined) => void = Void
): {
  value: AsyncGenerator<T>
  error: Promise<AnyError | undefined>
} => {
  let resolve: (value: AnyError | undefined) => void
  const error: Promise<AnyError | undefined> = new Promise(r => (resolve = r))

  const generator = async function* () {
    let err: AnyError | undefined
    try {
      for await (const item of stream) {
        yield item
      }
    } catch (e) {
      err = Failure(e).error
    } finally {
      // also reached when the consumer abandons the stream early: the error
      // promise resolves and the cleanup runs on every exit
      resolve(err)
      cleanup(err)
    }
  }

  return {
    value: generator(),
    error,
  }
}
